enum SoftwareOperatingMode {
  FleetControl = "FleetControl",
  Eco = "Eco",
  Smart = "Smart",
  Basic = "Basic",
}

export default SoftwareOperatingMode;
